import { render, staticRenderFns } from "./UiInput.vue?vue&type=template&id=158b8ff7&scoped=true&"
import script from "./UiInput.vue?vue&type=script&lang=js&"
export * from "./UiInput.vue?vue&type=script&lang=js&"
import style0 from "./UiInput.vue?vue&type=style&index=0&id=158b8ff7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158b8ff7",
  null
  
)

export default component.exports